import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  FormGroup,
  List,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useState } from "react";
import { useBoundStore } from "useStore";
import LightTooltip from "views/Components/Shared/Components/LightTooltip";

function Options({ closeTooltip }) {
  const selectedAdStates = useBoundStore(
    (state) => state.campaignManagerSelectedAdStates,
  );

  const toggleSelectedAdState = useBoundStore(
    (state) => state.toggleCampaignManagerSelectedAdState,
  );

  const adStates = useBoundStore((state) => state.campaignManagerAdState);

  const selectedAdStatesCount = selectedAdStates.length;

  const isAllAdStatesSelected = selectedAdStatesCount === adStates.length;
  const isIndeterminate = !isAllAdStatesSelected;
  const isCheckboxChecked = isAllAdStatesSelected;

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    adStates.forEach((adState) => {
      toggleSelectedAdState(adState.label, isChecked);
    });
  };

  return (
    <List
      sx={{
        width: "340px",
        maxWidth: 340,
        bgcolor: "background.paper",
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={isCheckboxChecked}
                indeterminate={isIndeterminate}
                onChange={handleSelectAll}
              />
            }
            label={
              <Typography
                sx={{
                  pl: 2,
                  color: "rgba(0, 0, 0, 0.87)",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "700",
                  letterSpacing: "0.15px",
                  padding: "12px",
                }}
              >
                Ad State:
              </Typography>
            }
          />
        </Stack>
      }
    >
      <Divider />
      <List component="div" disablePadding>
        <Box
          sx={{
            maxHeight: "210px",
            overflowY: "auto",
          }}
        >
          <FormGroup sx={{ pl: 2 }}>
            {adStates?.map((adState, index) => (
              <FormControlLabel
                key={adState.data}
                sx={{
                  borderBottom:
                    index === adStates.length - 1
                      ? "none"
                      : "1px solid rgba(236, 240, 244, 1)",
                }}
                control={
                  <Checkbox
                    color="secondary"
                    checked={selectedAdStates?.includes(adState.label)}
                    onChange={() => {
                      toggleSelectedAdState(adState.label);
                    }}
                  />
                }
                label={
                  <Typography padding={1} paddingTop={2} paddingBottom={2}>
                    {adState.label}
                  </Typography>
                }
              />
            ))}
          </FormGroup>
        </Box>
      </List>
      <Divider />
      <Button
        color="secondary"
        onClick={closeTooltip}
        sx={{
          mt: 1,
        }}
      >
        CERRAR
      </Button>
    </List>
  );
}

export default function AdStateFilter() {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleToggleTooltip = () => {
    setOpen((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <LightTooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<Options closeTooltip={handleTooltipClose} />}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              padding: "12px",
              width: "182px",
              borderRadius: "4px",
              border: "1px solid rgba(0, 0, 0, 0.23)",
              cursor: "pointer",
            }}
            onClick={handleToggleTooltip}
          >
            <Typography
              sx={{
                color: "#00000099",
                fontSize: "16px",
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "24px",
                letterSpacing: "0.15px",
              }}
            >
              Ad State
            </Typography>
            <ArrowDropDownIcon
              sx={{
                fill: "#0000008F",
                width: "24px",
                height: "24px",
              }}
            />
          </Stack>
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
